import Card from '@/components/Card'
import Layout, { Stack } from '@/components/Layout'
import Text from '@/components/Text'
import { VariantProps } from '@/widgets/InstructorCard'
import * as styles from '@/widgets/InstructorCard/style'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(relativeTime)

const Standard = ({
  title,
  imageUrl,
  navigationAction,
  id,
  fixedAspectRatio = false,
  skills,
  wide = false,
  instructorCard = true,
}: Partial<VariantProps>): JSX.Element => {
  return (
    <Card
      theme="classic"
      shadow={true}
      overlay={false}
      backgroundImage={imageUrl}
      data-id={id}
      href={navigationAction?.url}
      fixedAspectRatio={fixedAspectRatio}
      instructorAsImgHeader={true}
      guideInfoFooter={true}
      blurredImgHeader={true}
      instructorCard={instructorCard}
      footer={
        <Layout>
          <Stack y>
            <Stack x={!wide} y={wide} alignItems="center" justifyContent="center" alignSelf="flex-end">
              {title && (
                <Text
                  size="xs"
                  responsiveSize={{
                    sm: 'sm',
                  }}
                  weight="lg"
                  className={styles.name}
                >
                  {title}
                </Text>
              )}
            </Stack>
            <Stack x={!wide} y={wide} alignItems="center" justifyContent="center">
              {skills && (
                <Text size="xxs" weight="sm" className={styles.skills}>
                  {skills[0]}
                </Text>
              )}
            </Stack>
            {
              <Stack
                x={!wide}
                y={wide}
                alignItems="center"
                justifyContent="center"
                alignSelf="flex-end"
                className={styles.guideInfo}
              ></Stack>
            }
          </Stack>
        </Layout>
      }
    />
  )
}

export default Standard
